import { Check } from 'lucide-react';
import type { NotifyIntent } from '@/domain/bands';
import type { Dictionary } from '@/i18n';

type NotifyDoneProps = {
  dict: Dictionary;
  intent: NotifyIntent;
};

/* What the lead sees once the survey has their contact. Shared by the dialog the
   standalone page opens and the inline form the embed uses, so the promise the page just
   made reads the same on both surfaces. */
export const NotifyDone = ({ dict, intent }: NotifyDoneProps) => (
  <div className="flex items-start gap-2 rounded-lg bg-grey-100 p-3">
    <Check className="mt-0.5 h-4 w-4 shrink-0 text-black" aria-hidden="true" />
    <div className="flex flex-col gap-0.5">
      <span className="text-sm font-bold text-black">{dict.notify.doneTitle}</span>
      <span className="text-[13px] leading-relaxed text-grey-800">{dict.notify[intent].done}</span>
    </div>
  </div>
);
